import { useContext } from 'react'

import { OrganizationContext, OrganizationSettings } from '@src/Infrastructure/Context/OrganizationContext'

export const useOrganization = (): OrganizationSettings => {
    const context = useContext(OrganizationContext)

    if (!context) {
        throw new Error('must be used within OrganizationContext')
    }

    return context
}
